import React, { Component, ReactDOM } from 'react';
import PropTypes from 'prop-types';
import * as defaultConfig from './graphConfig';

class Graph extends Component {
    constructor(...args) {
      super(...args);
    }

    componentDidMount() {
      let {
          options=defaultConfig,
          highcharts=window.Highcharts,
      } = this.props;
      let title = this.props.title;
      let { chart, xAxis, yAxis, tooltip, plotOptions, series } = options;
      options = Object.assign({}, defaultConfig, options);
      highcharts.chart('graphContainer'+title, options);
    }

    render() {
      let title = this.props.title;

      return (
          <div id={'graphContainer'+title}></div>
      );
    }
}

Graph.propTypes = {
  options: PropTypes.object
};


export default Graph;
